export default "__VITE_ASSET__QLlwgppY__"